// export const AddElementsToDefualtRatio = ({editor, component, appData,content, storageObjRef,setStorageObj, selectedItem})=>{

//     let defaultEditorData = JSON.parse(content[appData.deckId.default_aspect_ratio]?.editorData||"[]") ||[] ;
//     let currentEditorData =JSON.parse(content[selectedItem]?.editorData||"[]")||[];
//     let updatedContent = content
//     if (selectedItem !==appData.deckId.default_aspect_ratio &&defaultEditorData?.styles?.length< currentEditorData?.styles?.length){

    
//     defaultEditorData.styles.push(...currentEditorData.styles.slice(defaultEditorData.styles.length, currentEditorData.styles.length));
//     defaultEditorData.pages=currentEditorData.pages
    
//     let newContent =content;
//     newContent[appData.deckId.default_aspect_ratio].editorData=JSON.stringify(defaultEditorData);
//     setStorageObj(newContent)
//     updatedContent=newContent
//    // setStorageObj({...storageObjRef.current, storageObjRef.cuurent })
//     //storageObjRef.current 
//     //setStorageObj()
//     }else if (selectedItem ===appData.deckId.default_aspect_ratio ){
//         let ratios=["ratio_4_3", "ratio_16_9","ratio_59_41"];
//         let newContent = content;
//         ratios = ratios.filter(item => item !== appData.deckId.default_aspect_ratio );
       
//         ratios.forEach(( eachRatio)=>{
//             let EachRatio = JSON.parse(content[eachRatio]?.editorData||"[]")
          
//             if (EachRatio?.styles?.length){
             
        
//                 EachRatio.styles.push(...EachRatio.styles.slice(defaultEditorData.styles.length, EachRatio.styles.length));
//                 EachRatio.pages=defaultEditorData.pages;
//                 newContent[eachRatio].editorData=JSON.stringify(EachRatio);
//             }
//             // console.log(JSON.parse(updatedContent[appData.deckId.default_aspect_ratio]?.editorData))
//             //     console.log(JSON.parse(updatedContent["ratio_4_3"]?.editorData))
//             //     console.log("test", JSON.parse(updatedContent["ratio_59_41"]?.editorData))
//         })
//         setStorageObj(newContent)
//         updatedContent=newContent;
      
//     }
   
//     return updatedContent
// }

// export const UpdateHTMLForAllRatiosOLD = ({editor, component, appData,content, storageObjRef,setStorageObj, selectedItem, listOfIDRef})=>{
//     let updatedContent = content;
//     let ratios=["ratio_4_3", "ratio_16_9","ratio_59_41"];
//     let newContent = content;
//     let defaultEditorData= JSON.parse(content[appData.deckId.default_aspect_ratio]?.editorData||"[]") ||[] ;
//     let selectedEditorData = JSON.parse(content[selectedItem]?.editorData||"[]");

//     if (appData.deckId.default_aspect_ratio !==selectedItem ){
//     ratios = ratios.filter(item => item !== selectedItem );
//     ratios.forEach(( eachRatio)=>{
//         let EachRatio = JSON.parse(content[eachRatio]?.editorData||"[]")      
//         if (EachRatio?.styles?.length){
//             EachRatio.pages=selectedEditorData.pages;
//             // console.log(selectedEditorData?.styles?.length, selectedEditorData?.styles, "sriPada")
//             listOfIDRef.current.forEach((id)=>{
               
//                selectedEditorData.styles.forEach( (obj)=>{
//                     let getID = obj.selectors?.[0]?.name||obj.selectors?.[0]||""
//                      if (getID === "#"+id ||getID === id ){
//                        let newEachRatio=   EachRatio.styles.filter((objSub)=>{
//                             let getIDOrName = typeof objSub.selectors?.[0] === "string"? objSub.selectors?.[0]:objSub.selectors?.[0]?.name||"";
                           
//                             return "#"+id !== getIDOrName && id !== getIDOrName  
                
//                         } );
                       
//                         newEachRatio=[...newEachRatio,{...obj}]
//                         EachRatio.styles=newEachRatio
//                      }

//               } );
            
//               // IDStyles
               
//             })
//             //EachRatio.styles.push(...EachRatio.styles.slice(selectedEditorData.styles.length, EachRatio.styles.length));
//             newContent[eachRatio].editorData=JSON.stringify(EachRatio);
            
//         }else{
//             newContent[eachRatio]=selectedEditorData;
//         }
      
//     })
//     setStorageObj(newContent)
//     updatedContent=newContent;
//     }
//    else {
//     ratios = ratios.filter(item => item !== selectedItem );

//    }
//     return updatedContent

// }
export const UpdateHTMLForAllRatios=({editor, component, appData,content, storageObjRef,setStorageObj, selectedItem, listOfIDRef})=>{
    
    let selectedEditorData = JSON.parse(content[selectedItem]?.editorData || "[]");
    let EachRatio = JSON.parse(content[appData.deckId.default_aspect_ratio]?.editorData||"[]")  
    const isResponsiveDim = (dim) => typeof dim === "string" && dim.startsWith("dim_");
    if (isResponsiveDim(appData.deckId.default_aspect_ratio) || isResponsiveDim(selectedItem)) {
        return content;
    }

    if (appData.deckId.default_aspect_ratio !== selectedItem) { 
        if (content[appData.deckId.default_aspect_ratio]?.hasOwnProperty("editorData") && content[appData.deckId.default_aspect_ratio].css === "") {
            EachRatio = JSON.parse(content[selectedItem]?.editorData || "[]");
        }
         
        EachRatio.pages=selectedEditorData.pages;
        listOfIDRef.current.forEach((id)=>{
            selectedEditorData.styles.forEach( (obj)=>{
                 let getID = obj.selectors?.[0]?.name||obj.selectors?.[0]||""
                
                  if (EachRatio?.styles?.length > 0 && (getID === "#"+id ||getID === id ||(JSON.stringify(selectedEditorData.styles) !=="tab" && ( getID==="tab"||getID==="tab-container" ||getID==="tab"||getID==="tab-contents") ) )){
                    let newEachRatio=   EachRatio?.styles?.filter((objSub)=>{
                         let getIDOrName = typeof objSub.selectors?.[0] === "string"? objSub.selectors?.[0]:objSub.selectors?.[0]?.name||"";
                         return "#"+id !== getIDOrName && id !== getIDOrName  
             
                     } );
                    
                     newEachRatio=[...newEachRatio,{...obj}]
                     EachRatio.styles=newEachRatio
                  }

           } );
         
            // IDStyles
            if(content[appData.deckId.default_aspect_ratio ])
           content[appData.deckId.default_aspect_ratio ].editorData=JSON.stringify(EachRatio);
           setStorageObj(content)
         })
     
    }
    return content;

}